import { ga, amplitude } from 'js/analytics/adapters'
import { baseWebEventProps } from 'js/analytics/standardizedProps'

export const trackLogOut = () => {
  ga.track('log_out')
  amplitude.track('user_logout_web', {
    ...baseWebEventProps(),
    action_name: 'logout',
    action_type: 'active',
  })
}
